export const TMDB_API_KEY = process.env.REACT_APP_TMDB_API_KEY;
export const TMDB_BASE_URL = 'https://api.themoviedb.org/3';
export const TMDB_IMAGE_BASE_URL = 'https://image.tmdb.org/t/p/w500';
export const YOUTUBE_BASE_URL = 'https://www.youtube.com/watch?v=';
export const OPEN_LIBRARY_API = 'https://openlibrary.org';